import './login.css';
import Button from '../../components/button';
import { Link, useNavigate } from 'react-router-dom';
import React, { useState } from "react";
const API = process.env.REACT_APP_API_URL;


function CreateAccount() {
  const [formData, setFormData] = useState({ firstName: '', lastName: '', email: '', username: '' })
  const navigate = useNavigate();
  const [validEmail, setValidEmail] = useState(true);
  const [emailUsed, setemailUsed] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const responseCreate = await fetch(`${API}/api/users/createaccount`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      })

      console.log(responseCreate.status)
      if (responseCreate.status === 501) {
        setValidEmail(false);
        setemailUsed(false);
      }
      if (responseCreate.status === 404) {
        setValidEmail(true);
        setemailUsed(true);
      }
      if (responseCreate.status !== 201) throw new Error(responseCreate.status)
      const user = await responseCreate.json()


      sessionStorage.setItem("name", user.user.firstName);
      sessionStorage.setItem("username", user.user.username);
      sessionStorage.setItem("m1", user.user.finished_m1);
      sessionStorage.setItem("m2", user.user.finished_m2);
      sessionStorage.setItem("m3", user.user.finished_m3);
      sessionStorage.setItem("m4", user.user.finished_m4);
      sessionStorage.setItem("m5", user.user.finished_m5);
      sessionStorage.setItem("m6", user.user.finished_m6);

      console.log(user)

      localStorage.setItem("token", user.token);

      console.log("JWT Token:", user.token);


      window.location.href = "/logging";


    } catch (error) {
      console.error(error)
      console.error(error.message)
    }
  };

  return <div className='form'>
    <h1>Create Account</h1>
    <form onSubmit={handleSubmit}>

      <label class='input' type='text' name="username" placeholder="Your username..">
        Username (Case Sensitive): <input name="username" onChange={(e) => setFormData({ ...formData, username: e.target.value })} />
      </label>
      <label class='input' type='text' name="email" placeholder="Your email..">
        Email: <input name="email" onChange={(e) => setFormData({ ...formData, email: e.target.value.toLowerCase() })} />
      </label>
      <label class='input' type='text' name="firstName" placeholder="Your first name..">
        First Name: <input name="firstName" onChange={(e) => setFormData({ ...formData, firstName: e.target.value })} />
      </label>
      <label class='input' type='text' name="lastName" placeholder="Your last name..">
        Last Name: <input name="lastName" onChange={(e) => setFormData({ ...formData, lastName: e.target.value })} />
      </label>

      <input type="submit" value="Create a New Account" />
      {!validEmail ? (
        <p>Invalid email address</p>
      ) : (
        <p></p>
      )}
      {emailUsed ? (
        <p>Email address already in use.
          <div>
            <Link to="/login">
              Log in?
            </Link>
          </div>
        </p>
      ) : (
        <p></p>
      )}
    </form>

  </div>;
}

export { CreateAccount };
